import router from 'next/router'
import React, { useEffect } from 'react'

import { Redirect } from '@components/Redirect'
import { AppRoutes } from '@constants/app-routes'
import { CustomHead } from '@ui/sections/CustomHead'

function SmartPlatformPage() {
  useEffect(() => {
    router.replace(AppRoutes.portfolioPredictiveAnalyticsForGaming)
  }, [])

  return (
    <>
      <CustomHead
        title="Gamer churn risk prediction software"
        description="How to derive valuable insights from in-game data and turn them into a powerful resource-saving tool? Find the answer in our latest Gamedev industry case study."
        imagePath="/images/custom-head/custom-head-smart-system-for-gamer.webp"
      />
      <Redirect />
    </>
  )
}

export default SmartPlatformPage
